import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWeasylComponent } from './simple-icons-weasyl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWeasylComponent ],
    exports:      [ SimpleIconsWeasylComponent ],
    bootstrap:    []
})
export class SimpleIconsWeasylModule {}
